import {
	AerTooltipArrow,
	AerTooltipContent,
	AerTooltipTrigger,
	AerTooltip as Root,
} from "./AerTooltip";

export const AerTooltip = {
	Root: Root,
	Arrow: AerTooltipArrow,
	Content: AerTooltipContent,
	Trigger: AerTooltipTrigger,
};
